import { Checkbox } from 'antd';
import type { CheckboxChangeEvent } from 'antd';
import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import styles from './index.module.scss';

interface SelectAllMembersProps {
  className?: string;
  selectedMembers: ChatGroupMember[];
  allSelectedMembers: ChatGroupMember[];
  onAllSelect: (e: CheckboxChangeEvent) => void;
}

export default function SelectAllMembers({
  className = '',
  selectedMembers,
  allSelectedMembers,
  onAllSelect,
}: SelectAllMembersProps) {
  return (
    <div className={cls(styles.selectAll, className)}>
      {allSelectedMembers.length > 0 && (
        <Checkbox
          indeterminate={
            selectedMembers.length > 0 &&
            selectedMembers.length < allSelectedMembers.length
          }
          checked={
            selectedMembers.length > 0 &&
            selectedMembers.length === allSelectedMembers.length
          }
          onChange={onAllSelect}
        >
          Select All
        </Checkbox>
      )}
    </div>
  );
}
